import app from 'flarum/forum/app';
import Modal, { IInternalModalAttrs } from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import EngineVersionDropdown from './EngineVersionDropdown';
import EngineVersion from '../../common/models/EngineVersion';
import type Discussion from 'flarum/common/models/Discussion';
import type Mithril from 'mithril';

export interface EditEngineVersionModalAttrs extends IInternalModalAttrs {
  discussion: Discussion;
}

export default class EditEngineVersionModal extends Modal<EditEngineVersionModalAttrs> {
  selectedVersion: EngineVersion | null = null;
  loading: boolean = false;

  oninit(vnode: Mithril.Vnode<EditEngineVersionModalAttrs, this>) {
    super.oninit(vnode);

    // Get current engine version from discussion
    this.selectedVersion = this.attrs.discussion.engineVersion() as EngineVersion | null;
  }

  className() {
    return 'EditEngineVersionModal Modal--small';
  }

  title() {
    return app.translator.trans('laya-engine-version.forum.edit_engine_version.title');
  }

  content() {
    return (
      <div className="Modal-body">
        <div className="Form">
          <div className="Form-group">
            <label>{app.translator.trans('laya-engine-version.forum.edit_engine_version.label')}</label>
            <div style={{ marginTop: '10px' }}>
              <EngineVersionDropdown
                selectedVersion={this.selectedVersion}
                onselect={(version: EngineVersion) => {
                  this.selectedVersion = version;
                }}
              />
            </div>
          </div>
          <div className="Form-group" style={{ marginTop: '20px' }}>
            <Button
              className="Button Button--primary Button--block"
              type="submit"
              loading={this.loading}
              disabled={!this.selectedVersion}
            >
              {app.translator.trans('laya-engine-version.forum.edit_engine_version.submit')}
            </Button>
          </div>
        </div>
      </div>
    );
  }

  onsubmit(e: SubmitEvent) {
    e.preventDefault();

    if (!this.selectedVersion) return;

    this.loading = true;

    this.attrs.discussion
      .save({ engineVersionId: this.selectedVersion.id() })
      .then(() => {
        this.hide();
        m.redraw();
      })
      .catch(() => {
        this.loading = false;
        m.redraw();
      });
  }
}
